export default [
  'tradestation',
  'trading station',
  'tradestation com',
  'www.tradestation.com',
  'tradingstation',
  'tradestation.com',
  'what is tradestation',
  'tradestation group',
  'tradestation securities inc',
  'tradestation trading',
  'trade station',
  'trade-station.com',
  'tradestation free trading',
  'tradestation trading for free',
  'futures trading',
  'best brokers for futures trading',
  'tradestation es',
  'futures market',
  'futures trading platforms',
  'tradestation futures',
  'futures markets',
  'where can i trade futures',
  'futures online trading',
  'trading futures',
  'tradestation futures margin',
  'trade futures',
  'how to trade futures',
  'emini futures',
  'what is the stock market',
  'emini',
  'futures trading app',
  'futures brokers',
  'futures exchange',
  'commodities trading',
  'how to become day trader',
  'commodity trading',
  'micro e-mini futures',
  'Futures exchanges',
  'futures trading account',
  'future trading platform',
  'e micro futures',
  'futures trading brokers',
  'futures oil trading',
  's and p futures',
  'think or swim',
  's&p',
  'think or swim',
  'options trading',
  'options trading platform',
  'options platform',
  'tradestation options trading',
  'trade options',
  'best options brokers',
  'tradestation option',
  'how to trade options',
  'where to trade options',
  'option stocks',
  'option trade',
  'how to buy options',
  'what is trading options',
  'options price',
  'day trading options',
];
